import { render, staticRenderFns } from "./MagnificationModal.vue?vue&type=template&id=2c8a8a9e"
import script from "./MagnificationModal.vue?vue&type=script&lang=js"
export * from "./MagnificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports